import { Box, makeStyles } from '@material-ui/core';
import WaitingTime from './WaitingTime';
import StatusRow from './StatusRow';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative', // 父元素设为相对定位
  },
  border: {
    position: 'absolute', // 将边框设为绝对定位
    top: 0,
    bottom: 0,
    left: '50%', // 水平居中
    width: '1px',
    backgroundColor: '#EFEFEF',
    transform: 'translateX(-50%)', // 将边框左移自身宽度的一半，使其水平居中
  },
}));

const StatusBar = ({ data }) => {
  const classes = useStyles();

  return (
    <Box display="flex" gridGap="2.5rem" width="100%">
      {/* Waiting time */}
      <WaitingTime data={data} />
      <Box className={classes.container}>
        <div className={classes.border} />
      </Box>
      {/* Status */}
      <StatusRow data={data} />
    </Box>
  );
};

export default StatusBar;
